import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EventNavigationProvider {
    constructor(public http: HttpClient) { }

    loadNavigation(): Observable<any> {
        return this.http.get('assets/json/eventNavigation.json');
    }
    loadNavigationDynamic(): Observable<any> {
        return this.http.get('assets/json/eventNavigationDynamic.json');
    }
    loadNavigationTabs(isCommunity?: boolean, hasAgenda?: boolean): any[] {
        return [
            {
                "linkIcon": "im-event-navigation_event-wall",
                "linkPage": 3,
                "linkName": isCommunity ? "Community Wall" : "Event Wall",
                "linkSegment": "USER"
            },
            {
                "linkIcon": "im-event-navigation_find-match",
                "linkPage": 2,
                "linkName": "Find Match",
                "linkSegment": "all"
            },
            {
                "linkIcon": "im-event-navigation_info-calendar",
                "linkPage": 0,
                "linkName": hasAgenda ? "Agenda / Info" : (isCommunity ? "Community Info" : "Event Info"),
                "linkSegment": ""
            },
            {
                "linkIcon": "im-event-navigation_exhibitors",
                "linkPage": 6,
                "linkName": "Virtual Booths",
                "linkSegment": "",
                "active": true
            }
        ];
    }
    loadNavigationTabsDynamic(isCommunity?: boolean): any[] {
        return [
          (!isCommunity ?
            {
                "linkIcon": "im-event-navigation_event-picks",
                "linkPage": 7,
                "linkName": "Ticket",
                "linkSegment": "",
                "active": true
            } : {}),
            {
                "linkIcon": "im-event-navigation_agenda",
                "linkPage": 1,
                "linkName": "Agenda",
                "linkSegment": "AGENDA",
                "active": false
            },
            {
                "linkIcon": "im-event-navigation_appearance",
                "linkPage": 4,
                "linkName": "Appearance",
                "linkSegment": "",
                "active": true
            },
            /*{
                "linkIcon": "im-event-navigation_event-contacts",
                "linkPage": 2,
                "linkName": isCommunity ? "Community Contacts" : "Event Contacts",
                "linkSegment": "contacts",
                "active": true
            },
            {
                "linkIcon": "im-event-navigation_q-a",
                "linkPage": 3,
                "linkName": "Q & A",
                "linkSegment": "Q_AND_A",
                "active": false
            },
            {
                "linkIcon": "im-event-navigation_polls",
                "linkPage": 3,
                "linkName": "Polls",
                "linkSegment": "POLL",
                "active": false
            },
            {
                "linkIcon": "im-event-navigation_polls",
                "linkPage": 3,
                "linkName": "Prize Game",
                "linkSegment": "PRIZE_GAME",
                "active": false
            }*/
        ];
    }
}



// WEBPACK FOOTER //
// ./src/providers/event-navigation/event-navigation.ts